'use client';

import { PageRow } from '@components/PageRow';
import { CbSpacing300, CbSpacing500 } from '@coolblue-development/design-tokens';
import { Button, FactSlogan, Flex, Typography } from '@coolblue-development/freddy';
import { useClientLogger } from '@coolblue-development/next-config/client';
import { useTranslation } from '@i18n/useTranslation';
import {
  Status,
  Statuses,
  VacancyDetailPageHeaderBlock,
  VacancyGroupDetailPageHeaderBlock
} from '@sharedTypes';

import { ChipUSPs } from './ChipUsps';
import { handleToBlockCallToAction } from './handleToBlockCallToAction';

type Props = {
  block: VacancyDetailPageHeaderBlock | VacancyGroupDetailPageHeaderBlock;
  pageStatus: Status;
};

export const Header = ({ block, pageStatus }: Props) => {
  const { title, description, chipUSPs } = block;

  const { t } = useTranslation('vacancyDetail.header');

  const logger = useClientLogger();

  return (
    <PageRow>
      <Flex direction='column' gap={{ xs: CbSpacing300, md: CbSpacing500 }} alignItems='flex-start'>
        <Typography variant='h1' marginBottom={0}>
          <FactSlogan
            fact={title}
            sx={theme => ({
              fontSize: '2.2rem',
              [theme.breakpoint.minWidth('md')]: {
                fontSize: '4.4rem'
              }
            })}
          />
        </Typography>

        <ChipUSPs chipUSPs={chipUSPs} />

        <Typography
          variant='intro'
          marginBottom={0}
          fontSize={{ md: '2rem' }}
          lineHeight={{ md: '1.6' }}
        >
          {description}
        </Typography>
        {pageStatus !== Statuses.UNPUBLISHED && (
          <Button
            variant='action'
            fullWidthUntil='md'
            onClick={() => handleToBlockCallToAction(logger)}
          >
            {t('applyButton')}
          </Button>
        )}
      </Flex>
    </PageRow>
  );
};
